// @ts-ignore
import { theme } from '~tailwind.config'

/** 螢幕斷點 */
export type Screen = 'sm' | 'md' | 'lg' | 'xl'
export const screens: { [key in Screen]: string } = theme.screens
